import React from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import _ from "lodash";

const ConfirmClose = ({
  close = () => {},
  main_title = "",
  sub_title = "",
  cancel_button_text = "Cancel",
  action_button_text = "Home",
  cancel_button = () => {},
  action_button = () => {},
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-8">
      <div className="relative bg-white rounded-2xl shadow-3xl max-w-md overflow-x-hidden w-full">
        <div className="w-full absolute top-[-200px] h-[332px] bg-[#FCF0DB] rounded-b-[100%]"></div>
        <img src={ImageLinks.info_light_yellow} alt="info" className="absolute top-[40px] left-1/2 -translate-x-1/2 w-12 h-12" />
        <div className="flex mt-20 flex-col px-6 py-10 pt-[10px] justify-center items-center text-center gap-8">
          <p className="px-6 mt-20 font-custom text-xl font-semibold text-dark_black">
            {main_title}
          </p>
          {!_.isEmpty(sub_title) && (
            <div className="rounded-lg bg-[#FFEAEC80] p-2.5">
              <p className="font-custom font-medium text-xs text-error">
                {sub_title}
              </p>
            </div>
          )}
          <div className="flex w-full gap-3 justify-center px-6">
            <button
              onClick={cancel_button}
              className="font-custom text-base font-semibold btn w-[50%] text-secondary bg-white rounded-[30px] border-2	border-secondary"
            >
              {cancel_button_text}
              {/* Cancel */}
            </button>
            <button
              onClick={action_button}
              className="font-custom text-base font-semibold btn w-[50%] bg-primary text-white cursor-not-allowed rounded-[30px]"
            >
              {action_button_text}
              {/* Home */}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmClose;
